var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumberEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.968,
    cy: 25.968,
    r: 25.968,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.98 19.934h7.323l1-4a1.234 1.234 0 012.393.6l-.85 3.4h2.12a1.233 1.233 0 110 2.467H33.23l-1.85 7.4h4.587a1.233 1.233 0 110 2.466h-5.204l-1 3.998a1.233 1.233 0 11-2.393-.598l.85-3.4h-7.323l-1 3.998a1.233 1.233 0 11-2.393-.598l.85-3.401h-2.12a1.233 1.233 0 110-2.467h2.736l1.85-7.4h-4.587a1.233 1.233 0 110-2.466h5.204l1-3.999a1.234 1.234 0 012.393.599l-.85 3.4zm-.617 2.466l-1.85 7.4h7.324l1.85-7.4h-7.324z",
    fill: "#9EC3CC"
  })));
}
export default SvgNumberEmpty;